import axios from 'axios';

// 创建 axios 实例
const apiClient = axios.create({
  // 基础 URL 可以根据你的后端 API 地址设置，例如 /api
  // 如果前端和后端部署在同一个域下，可以直接使用相对路径
  // 如果部署在不同域，需要设置完整的 URL，例如 http://localhost:3001/api
  baseURL: '/api', // 假设 API 都在 /api 路径下
  timeout: 10000, // 请求超时时间 10 秒
  headers: {
    'Content-Type': 'application/json',
  }
});

// 添加请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('authToken');
    if (token) {
      // 如果存在 token，则添加到 Authorization 请求头
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Axios Interceptor: Added token to request headers.'); // 调试信息
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    console.error('Axios Request Interceptor Error:', error);
    return Promise.reject(error);
  }
);

// 你还可以添加响应拦截器来统一处理响应错误或数据转换
// apiClient.interceptors.response.use(
//   (response) => {
//     // 对响应数据做点什么
//     return response;
//   },
//   (error) => {
//     // 对响应错误做点什么
//     if (error.response && error.response.status === 401) {
//       // 例如，如果收到 401 未授权错误，可以触发登出逻辑
//       console.log('Axios Response Interceptor: Unauthorized (401), logging out.');
//       // 在这里调用 logout 函数，可能需要通过事件或 context
//       // 注意：直接在这里调用 useAuth() 是不行的，因为它是一个 hook
//       // 可能需要触发一个全局事件，或者检查 AuthContext 是否已加载
//       // window.dispatchEvent(new Event('auth-error')); // 示例事件
//     }
//     return Promise.reject(error);
//   }
// );

export default apiClient; 